// No-op shim for @react-native-firebase/crashlytics on web
const crashlytics = () => ({
  recordError: (_error: Error) => {},
  log: (_message: string) => {},
  setUserId: (_id: string) => {},
  setAttribute: (_key: string, _value: string) => {},
  setAttributes: (_attrs: Record<string, string>) => {},
  crash: () => {},
});

export default crashlytics;
